import React from "react";
import { Redirect } from "../components/Utilities";
import ContactForm from "../components/Contact/ContactForm";

const Contact = (): any => {
  return (
    <div id="contact">
      <ContactForm Title="Contact" />
    </div>
  );
};
export default Contact;
